import { Skeleton } from '@/components/atoms/Skeleton';
import useBreakpoint from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function CheckoutContainerDesktopFallback() {
  const { widthWindow } = useBreakpoint();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: theme.spacing[widthWindow > 1000 ? 3 : 5],
        ...(widthWindow > 1000 ? { flexWrap: 'wrap' } : {}),
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: theme.spacing[1],
          ...(widthWindow > 1000 ? { flexWrap: 'wrap' } : {}),
        }}
      >
        <Skeleton style={{ height: 32, width: 100 }} />
        <Skeleton style={{ height: 24, width: 62 }} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          gap: theme.spacing[4],
        }}
      >
        <Skeleton style={{ height: 40, width: 40 }} />
        <Skeleton style={{ height: 40, flex: 1 }} />
      </div>
    </div>
  );
}
